import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

const ProtectedRoute = ({ requiredPermission, component: Component, ...rest }) => {
  
  // On récupère l'utilisateur et le token depuis Redux
  const { user, token } = useSelector((state) => state.signin);

  // ====================== DÉBUT DU BLOC DE DÉBOGAGE ======================
  // Ce bloc s'exécutera à chaque fois qu'une route protégée est rendue
  console.group(`--- Vérification ProtectedRoute pour la page : ${rest.path} ---`);
  console.log("Permission requise :", requiredPermission);
  console.log("Token présent :", token ? 'Oui' : 'Non'); // Affiche Oui ou Non
  console.log("Objet 'user' complet depuis Redux :", user);
  // On utilise l'optional chaining (?.) pour éviter une erreur si 'user' est null
  console.log("Permissions trouvées dans l'objet 'user' :", user?.permissions); 
  // ======================= FIN DU BLOC DE DÉBOGAGE =======================

  return (
    <Route
      {...rest}
      render={(props) => {
        // Cas 1: L'utilisateur n'est pas du tout connecté
        if (!token) {
          console.log("Résultat : Blocage (pas de token). Redirection vers /sign-in.");
          console.groupEnd(); // Termine le groupe de logs
          return <Redirect to="/sign-in" />;
        }

        // Cas 2: La route nécessite une permission
        if (requiredPermission) {
          // Si l'utilisateur n'a pas la permission requise...
          if (!user?.permissions?.includes(requiredPermission)) {
            console.log(`Résultat : Blocage (permission '${requiredPermission}' manquante). Redirection vers /unauthorized.`);
            console.groupEnd(); // Termine le groupe de logs
            return <Redirect to="/unauthorized" />;
          }
        }
        
        // Si tout est bon, on affiche la page
        console.log("Résultat : Accès autorisé.");
        console.groupEnd(); // Termine le groupe de logs
        return <Component {...props} />;
      }}
    />
  );
};

export default ProtectedRoute;